import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-right" }
const _hoisted_2 = {
  class: "btn btn-primary",
  href: "/login?redirect-to=/subscription"
}
const _hoisted_3 = { class: "small text-muted mt-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" The step a guest goes through before ordering, where CartValidation would otherwise\n\t     show the order and trial buttons. For now a link to log in; the email-code\n\t     identification replaces this component's content, and nothing around it changes. "),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", _hoisted_2, _toDisplayString(_ctx.__("Log in")), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.__("for a quote, an evaluation, an order")), 1 /* TEXT */)
    ])
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}